module.exports = __webpack_public_path__ + "./fonts/Foco_W_Bd.ttf";